import React, { useContext, useState } from "react";
import TickerContext from "../../../../context/ticker";
import MyContext from "../../../../context/MyContext";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import ProjectContext from "../../../../context/ProjectContext";
import Swal from "sweetalert2";
import UpdateTags from "../../../../Search/UpdateTags";
//file updated
const Shape = (props) => {
  const {
    EditorZoom,
    timelineZoomVal,
    setLayersData,
    LayersData,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    calculateTimeByWidth,
    calculateWidthByDuration,
    Tl_TotalTime,
    seteditableObject,
  } = useContext(MyContext);

  const { authenticationData, Role } = useContext(AuthContext);
  const { slides, setslides } = useContext(ProjectContext);
  const [open, setOpen] = useState(false);
  const [itemId, setItemId] = useState(0);
  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);

  const addImage = (e, url) => {
    // debugger;
    // console.log(e);
    let ratio = e.target.clientHeight / e.target.clientWidth;

    var stack = [...UndoLayer];
    var PrevArray;

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    ImageURLToBase64(url)
      .then(function (baseStr) {
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === Goto.key) {
            array[i].ImageSrc = baseStr;
            array[i].height = array[i].width * ratio;
          }
        }
        // debugger;
        setLayersData(array);
        setChangeCount(ChangeCount + 1);
        setGoto({
          menu: null,
          innerMenu: null,
          key: null,
        });
      })
      .catch(function () {
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === Goto.key) {
            array[i].ImageSrc = url;
            array[i].height = array[i].width * ratio;
          }
        }
        // debugger;
        setLayersData(array);
        setChangeCount(ChangeCount + 1);
        setGoto({
          menu: null,
          innerMenu: null,
          key: null,
        });
      });
  };

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const ObjectTags = (photos) => {
    setOpen(true);
    setItemId(photos.target.id);
  };

  const deleteShape = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        var formdata = new FormData();

        formdata.append("id", e.target.id);
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Administration/deleteShape",
            formdata,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.response == "Success") {
              props.getObjectFolderData();
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
              Swal.fire("Deleted!", "Not deleted", "Failed");
            }
          })
          .catch((excetion) => {
            //console.log(excetion);
          });
      }
    });
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const ImageClick = (IUrl, ITop, ILeft, IWidth, Iheight, ImageBlob, event) => {
    var stack = [...UndoLayer];
    var PrevArray;

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;

    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].type === "image") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    // let TickPos;
    // let trans = document.getElementById('tickerHead').style.transform;
    // if (trans != "") {
    //   trans = trans.split('(')
    //   trans = trans[1].split(',')
    //   trans = trans[0].split('px')
    //   trans = eval(trans[0]);
    //   TickPos = trans
    // }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);
    let newEntryLayerData = {
      Added: true,
      key: checkKey + 1,
      AnimationId: makeid(5),
      type: "basicShape",
      bgColor: "#838383",
      Name: `shape-${typelength}`,
      canvas: null,
      EditorZoom: EditorZoom,
      video: null,
      TimelineZoom: timelineZoomVal,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      duration: totalTime,
      startTime: currentTime,
      originalX: null,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      InClass: "",
      OutClass: "",
      typeIcon: "vrpano",
      STdiff: null,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      angle: 0,
      svgContent: IUrl,
      svgURL: props.picurl,
      crop: "false",
      lock: false,
      x: ILeft,
      y: ITop,
      flip: "scaleX(1)",
      width: IWidth,
      height: Iheight,
      toolbar: true,
      FurtherSetting: false,
      opacity: 1,
      originalOpacity: 1,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CanvasZoom: EditorZoom,
      ImageBlob: ImageBlob,
      startPositionOnTimeline: TickerPosition,
      player: false,
      transparency: false,
      textColor: null,
      stroke: 0,
      strokeColor: null,
      rotateAngle: 0,
      ColorsFound: [],
      InMultiDrag: false,
      showDiv: true,
      showColor: true,
    };

    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    // debugger;
    setLayersData(LayersData.concat(newEntryLayerData));

    seteditableObject({
      showPanel: true,
      editableItem: newEntryLayerData,
    });
    // const array = Array.from(slides)
    // let change = false;
    // for(let i = 0; i < array.length; i++)
    // {
    //   if(array[i].IsActive)
    //   {
    //       array[i].LayerData.push(newEntryLayerData)
    //       change = true;
    //   }
    // }

    // if(change)
    // {
    //   setTimeout(() => {
    //     setslides(array)
    //   }, 7000);

    // }

    setChangeCount(ChangeCount + 1);
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const ImageConverter = (e) => {
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let _widthPercentage = 300 / CanvasWidth;
    let _heightPercentage = 300 / canvasHeight;

    //commented out to fix an issue in preview and fix ratio of shape addition...
    // let _heightPercentage = parseInt(300 * (e.target.offsetHeight / 163)) / 593;
    let _width = (CanvasWidth * _widthPercentage) / 2;
    let _height = (canvasHeight * _heightPercentage) / 2;
    // let halfCanvas = CanvasWidth / 2 + EditorZoom;
    // let ratio = (CanvasWidth - halfCanvas) / animationWidth;
    // let _widthPercentage = 300 / animationWidth;
    // let _heightPercentage = 300 / animationHeight;
    // let _width = animationWidth * ratio;
    // let _height = animationHeight * ratio;
    //var height = parseInt(300 * (e.target.offsetHeight / 163))
    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);
    // debugger;
    ImageURLToBase64(props.picurl)
      .then(function (baseStr) {
        ImageClick(baseStr, top, left, _width, _height, null, e);
      })
      .catch(function () {
        ImageClick(props.picurl, top, left, _width, _height, null, e);
      });
  };

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Shapes/getSvgContent?p=" +
            props.reletivePath,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.svg != null && response.data.svg != "") {
            // debugger
            //console.log(response.data.svg);
            let div = document.createElement("div");
            div.innerHTML = response.data.svg;
            let svg = div.children[0];
            let innerChild = svg.children[0];
            //console.log(svg.innerHTML);
            resolve(response.data.svg);
          } else {
            reject();
          }
        })
        .catch((error) => {
          //console.log(error);
          reject();
        });
    });
  };

  return (
    <>
      <div
        className="AnimatedBackgorund_items_start"
        style={{
          display: "inline-block",
          width: "33%",
          cursor: "pointer",
          position: "relative",
        }}
      >
        {Role == "admin" && (
          <>
            <span
              id={props.id}
              onClick={(e) => ObjectTags(e)}
              className="material-icons"
              style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                color: "#9f9393",
                zIndex: "1",
              }}
            >
              edit
            </span>
            <span
              onClick={deleteShape}
              id={props.id}
              className="material-icons"
              style={{
                position: "absolute",
                top: "0px",
                right: "20px",
                color: "#9f9393",
                zIndex: "1",
              }}
            >
              delete
            </span>
          </>
        )}
        <img
          src={props.url}
          alt=""
          className="shapeSize cust-pad-img"
          onClick={(e) => addImage(e, props.picurl)}
        />
        {Goto.menu !== "shape" && (
          <div
            className="dragdiv"
            picurl={props.picurl}
            onClick={(e) => ImageConverter(e)}
            draggable="true"
          />
        )}
      </div>
      {open === true && (
        <UpdateTags
          itemId={itemId}
          type={"Shapes"}
          open={open}
          setOpen={setOpen}
        />
      )}
    </>
  );
};
export default Shape;
